export const warnTypeList = [
  { label: "变现收入", value: 1 },
  { label: "推广总计", value: 2 },
  { label: "变现活跃arpu", value: 3 },
  { label: "新增单价", value: 4 },
  { label: "新增ROI", value: 5 },
  { label: "当前变现ROI", value: 6 },
  { label: "day1留存", value: 7 },
  { label: "day3留存", value: 8 },
  { label: "day7留存", value: 9 },
];

export const noticeColumn = [
  { id: 0, key: "installDay", name: "日期", width: 150 },
  { id: 1, key: "platform", name: "平台", width: 150 },
  { id: 2, key: "productName", name: "产品名称", width: 250 },
  { id: 3, key: "warnTypeName", name: "预警类型", width: 200 },
  { id: 4, key: "mediaSource", name: "渠道", width: 150 },
  { id: 5, key: "geo", name: "地区", width: 150 },
  { id: 6, key: "campaign", name: "campaign", width: 150 },
  { id: 7, key: "income", name: "变现收入", width: 150 },
  { id: 8, key: "popu", name: "推广总计", width: 150 },
  { id: 9, key: "arpu", name: "arpu", width: 150 },
  { id: 10, key: "cresCost", name: "新增单价", width: 150 },
  { id: 11, key: "incrRoi", name: "新增ROI", width: 150 },
  { id: 12, key: "roi", name: "当前变现ROI", width: 150 },
  { id: 13, key: "retention1", name: "day1留存", width: 150 },
  { id: 14, key: "retention3", name: "day3留存", width: 150 },
  { id: 15, key: "retention7", name: "da7留存", width: 150 },
  { id: 16, key: "warnReason", name: "异常原因", width: 150 },
  { id: 17, key: "confirmor", name: "确认人", width: 150 },
  { id: 18, key: "remark", name: "后需调整", width: 220 },
];
export const ruleColumn = [
  { id: 0, key: "id", name: "序号", width: 100 },
  { id: 1, key: "warnTypeName", name: "预警类型", width: 150 },
  { id: 2, key: "warnDetailName", name: "预警类型情况", width: 150 },
  { id: 3, key: "description", name: "判断标准" },
];
export const platformList = [
  { label: "全部平台", value: -1 },
  { label: "安卓", value: 1 },
  { label: "谷歌", value: 2 },
  { label: "苹果", value: 3 },
];
export const statusList = [
  { label: "大幅上涨", value: 1, key: "rise" },
  { label: "大幅下降", value: 2, key: "descend" },
  { label: "持续上涨", value: 3, key: "turnRise" },
  { label: "持续下降", value: 4, key: "turnDescend" },
  { label: "上涨趋势", value: 5, key: "rise" },
  { label: "下降趋势", value: 6, key: "descend" },
  { label: "持续低于100%", value: 7, key: "turnDescend" },
  { label: "首次低于100%", value: 8, key: "descend" },
];
